// extracted by mini-css-extract-plugin
export var acceptButton = "_10-5";
export var fullContent = "_10-4";
export var link = "_10-6";
export var linkIcon = "_10-7";
export var sideContent = "_10-3";
export var sideImage = "_10-2";
export var sideImageWrapper = "_10-1";
export var splitLayout = "_10-0";